import TabelUser from "./TabelUser";

export default TabelUser;